var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 200,
    viewBox: "0 0 263 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.679 100.006C262.679 71.8523 234.675 47.3398 193.298 34.5626C180.52 -6.82602 155.996 -34.8306 127.854 -34.8306C99.7124 -34.8306 75.1884 -6.82602 62.4112 34.5511C21.0226 47.3398 -6.98193 71.8523 -6.98193 100.006C-6.98193 128.159 21.0226 152.672 62.3997 165.449C75.1769 206.837 99.6895 234.831 127.843 234.831C155.996 234.831 180.509 206.826 193.286 165.449C234.675 152.672 262.668 128.159 262.668 100.006H262.679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaIcon);
export default __webpack_public_path__ + "static/media/DAIcon.6fe02b9c51fa047c1c941bdeb12dbbe2.svg";
export { ForwardRef as ReactComponent };